import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Header from '@components/Header';
import Footer from '@components/Footer';
import Head from 'next/head';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const styles = theme => ({
  root: {
    paddingTop: 58,
  },
  contentContainer: {
    paddingTop: 55,
    paddingBottom: 55,
  },
});

const Index = ({ classes }) => {
  return (
    <div className={classes.root}>
      <Head>
        <title>Terms of Service - SellOnLive</title>
      </Head>
      <Header />
      <div className={['container', classes.contentContainer].join(' ')}>
        <h1>Sellonlive Merchant Payment and Refunds</h1>
        <div>
          <ol>
            <li>
              Upon completion of account creation, SOL shall automatically create a payment account
              for the Merchant based on the information provided. The payment gateway services
              provider to be engaged for the creation of the payment account shall be solely decided
              by SOL. The Merchant herein expressly agrees, consents and authorize SOL to collect
              payments made by the Purchaser on behalf of the Merchant.
            </li>
            <li>
              <p>
                Parties agree that the structure and flow of the payment for products and payment of
                fees, if any, shall be as follows: ˝
              </p>
              <ul>
                <li>
                  Once the Purchaser agrees to purchase the Product and confirmation is made through
                  the transaction link and web page, the Purchaser shall be prompted to make the
                  necessary payments through SOL’s designated payment gateway;
                </li>
                <li>
                  The Purchaser may choose to pay by way of bank transfer, credit card or debit
                  card. Upon successful payment of the monies by the Purchaser, the monies shall be
                  paid to the payment account as set up by SOL;
                </li>
                <li>
                  The settlement of monies to the Merchant shall follow the time period as stated in
                  Appendix A below. All settlement of monies shall be made to the Merchant’s
                  registered business banking account. The payment of fees for the payment gateway
                  shall occur during the said period and shall be deducted before settlement of
                  monies is completed. Further details on the structure, flow and relevant
                  transactional period shall be set out in Appendix A attached herein.
                </li>
              </ul>
            </li>
            <li>
              <p>The Merchant herein agrees to adhere to the refund policies as follows:</p>
              <ul>
                <li>
                  Each product sold on the Platform shall have a general refund period of Seven (7)
                  days from the date of receipt of the Product by Purchaser. In the event that the
                  Merchant is desirous of setting its own refunding period and/or own refunding
                  policy, it shall do so by expressly stating the refunding period in its store page
                  and/or during their live streaming session in which event the period of time
                  stated herein shall not be applicable;
                </li>
                <li>
                  The Purchaser shall contact the Merchant directly if a request for a refund of
                  monies paid for the purchase of a Product is made. The Merchant shall be solely
                  liable and responsible for the process of refunding the monies paid by Purchaser.
                  It is expressly agreed that only the Merchant shall have the sole discretion in
                  deciding to process the refund for the Purchaser and that SOL shall not take part
                  in any stages of the refunding process;
                </li>
                <li>
                  Notwithstanding that the Merchant has received monies after the settlement, it is
                  hereby expressly agreed by the Merchant that a full refund of the monies
                  equivalent to the price of the Products shall be made in the event that a request
                  for refunds is confirmed. The Merchant shall arrange for the refund to the
                  Purchaser;
                </li>
                <li>
                  Parties hereby agree that regardless of the refunds being made, the scale fees
                  from the sale and purchase transaction must be paid to SOL. SOL shall not be
                  liable to pay any of the scale fees and/or to return the same to the Merchant for
                  purposes of refunding the Purchaser;
                </li>
                <li>
                  In the event that the Merchant has for whatsoever reason deleted its account in
                  the Platform and the Purchaser is unable to make any contact to the Merchant for
                  item and monies refund purposes, SOL hereby reserves the right to release any
                  information in relation to the Merchant to said Purchaser if so required to assist
                  in their attempts to recover any monies due and owing by the Merchant.{' '}
                </li>
              </ul>
            </li>
            <li>
              <p>
                Notwithstanding to Clause 8.3 above, the Merchant may set its own refunding policies
                in the event the Products sold are perishable in nature and/or not suitable to be
                returned in its original state. For the purposes of setting its own refunding
                policies, the Merchant shall do the following:
              </p>
              <ul>
                <li>
                  The Merchant shall provide a list of information to SOL as to the items which are
                  perishable in nature and not suitable to be categorised as Products which may fall
                  under the general refund policy stated in Clause 8.3 above;
                </li>
                <li>
                  SOL shall have the sole discretion to approve or otherwise the list provided by
                  the Merchant. In the event that the list is approved, the Merchant shall expressly
                  list the Products as non-refundable on the store page.
                </li>
              </ul>
            </li>
            <li>
              For the purposes of the refund policy and to act as an intermediary between the
              Merchant and Purchaser, it is agreed that SOL shall reserve the rights to release any
              information in regards to the purchase of the Products to the Purchaser if so
              required.
            </li>
            <li>
              The Merchant shall not claim for any losses, damages, costs and/or fees from SOL
              and/or the payment gateway provider in the event such losses, damages, costs and/or
              fees occurs as a result of the refunds being made to the Purchaser.
            </li>
          </ol>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export const getServerSideProps = async ({ locale }) => {
  return {
    props: {
      locale,
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
};

export default withStyles(styles)(Index);
